import React from "react";
import { useLocation } from "react-router-dom";
import HomeOneHeader from "./common/HomeOneHeader";
import HomeOneFooter from "./common/HomeOneFooter";
import FloatingMenu from "./common/FloatingMenu";
import { ROUTES } from "../config/routes";

const Layout = (props) => {
  const location = useLocation();
  const pathname = String(location?.pathname || "").toLowerCase();
  const quranPath = String(ROUTES?.QURAN?.path || "/quran").toLowerCase();
  const isQuranRoute = pathname === quranPath || pathname.startsWith(`${quranPath}/`);

  return (
    <>
      <HomeOneHeader className={isQuranRoute ? "quran-route-site-header" : ""} />
        {props.children}
      <HomeOneFooter />
      <FloatingMenu />
    </>
  );
}

export default Layout;
